// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React, {useState} from 'react';
import {pick} from 'lodash';

interface NPSAnswerProps {
    message: any;
}

// Renders the NPS Answer block with predefined payload values.
export const NPSAnswer = (props: NPSAnswerProps) => {
    const {message} = props;
    const {
        event_body,
        label_negative: labelNegative,
        label_positive: labelPositive,
    } = pick(message, [
        'label_negative',
        'label_positive',
        'event_body.in_cx_answer.question',
        'event_body.in_cx_answer.value',
    ]);

    const {question, value: selectedIndex} = event_body?.in_cx_answer
        ? event_body?.in_cx_answer
        : {question: undefined, value: undefined};
    const [npsScores, setNpsScores] = useState(
        Array.from({length: 11}).fill({selectedClassName: ''}),
    );

    // Sets the selected class on all nps circles up to the selectedIndex.
    const setSelected = (activeIndex) => {
        {
            setNpsScores(
                npsScores.map((el, i) => {
                    return {
                        selectedClassName: i <= activeIndex ? 'selected' : '',
                    };
                }),
            );
        }
    };

    // Get the class color depending on the NPS index.
    const getIndexClass = (i) => {
        return i <= 6 ? 'danger' : i > 6 && i < 9 ? 'warning' : 'success';
    };

    const renderedNpsScores = () =>
        npsScores.map((el: any, i) => {
            return (
                <div key={i} className="message-cx__nps-circle-wrapper">
                    <div
                        key={i}
                        className={`message-cx__nps-circle ${
                            el.selectedClassName
                        } ${getIndexClass(i)}`}
                    >
                        <span>{i}</span>
                    </div>
                </div>
            );
        });

    React.useEffect(() => {
        setSelected(selectedIndex);
    }, [selectedIndex]);

    return (
        <div className="message-cx__nps-block">
            <div className="message-cx__nps-title-container">
                <span className="message-cx__nps-title">{question}</span>
            </div>
            <div className="message-cx__nps-circle-container">
                {renderedNpsScores()}
            </div>
            <div className="message-cx__nps-label-container">
                <span className="message-cx__nps-label-negative">
                    0 = {labelNegative}
                </span>
                <span className="message-cx__nps-label-positive">
                    10 = {labelPositive}
                </span>
            </div>
        </div>
    );
};
